import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	digestsNotificationsPageTitle: {
		defaultMessage: 'Digest notifications',
		id: 'personal-settings-digests-notifications.digests-notifications-page-title',
		description: 'Title for digest notifications page',
	},
	digestsNotificationsExplanation: {
		defaultMessage: 'Digests are a way to see important notifications about your projects.',
		id: 'personal-settings-digests-notifications.digests-notifications-explanation',
		description: 'Explanation for digest notifications page',
	},
	digestsNotificationsAbout: {
		defaultMessage: 'About digests',
		id: 'personal-settings-digests-notifications.digests-notifications-about',
		description: 'Link to page about digests',
	},
	digestsNotificationsControl: {
		defaultMessage: 'Control your digest notifications:',
		id: 'personal-settings-digests-notifications.digests-notifications-control',
		description: 'Text to control digest notifications',
	},
	digestsNotificationsReceiveNotifications: {
		defaultMessage: 'Receive notifications via:',
		id: 'personal-settings-digests-notifications.digests-notifications-receive-notifications',
		description: 'Text to receive notifications via a particular channel, e.g. email, in-app',
	},
	digestsNotificationsReceiveNotificationsEmail: {
		defaultMessage: 'Email',
		id: 'personal-settings-digests-notifications.digests-notifications-receive-notifications-email',
		description: 'Text for receiving notifications via email',
	},
	digestsNotificationsReceiveNotificationsInProduct: {
		defaultMessage: 'In product',
		id: 'personal-settings-digests-notifications.digests-notifications-receive-notifications-in-product',
		description: 'Text for receiving notifications via in-product',
	},
	digestsNotificationsReceiveNotificationsSlack: {
		defaultMessage: 'Slack',
		id: 'personal-settings-digests-notifications.digests-notifications-receive-notifications-slack',
		description: 'Text for receiving notifications via slack',
	},
	digestsNotificationsDueOrOverdueIssues: {
		defaultMessage: 'Due or overdue issues',
		id: 'personal-settings-digests-notifications.digests-notifications-due-or-overdue-issues',
		description: 'Text for due or overdue issues',
	},
	digestsNotificationsDueOrOverdueWork: {
		defaultMessage: 'Due or overdue work items',
		id: 'personal-settings-digests-notifications.digests-notifications-due-or-overdue-work',
		description: 'Text for due or overdue work items',
	},
	digestsNotificationsProjectInviter: {
		defaultMessage: "You've invited a new user and they don't have assigned work items",
		id: 'personal-settings-digests-notifications.digests-notifications-project-inviter',
		description: 'Text for project inviter notifications',
	},
});
